const ASK_SENIOR_V3_BASE_URL = "http://35.154.179.196:8000";
const ASK_SENIOR_V3_DEV_URL = "http://localhost:8000";
export default { ASK_SENIOR_V3_BASE_URL, ASK_SENIOR_V3_DEV_URL };
